import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="main-footer">
      <strong>Copyright &copy; 2025 <a href="/">PsicoAdm</a>.</strong>
      Todos os direitos reservados.
      <div className="float-right d-none d-sm-inline-block">
        <b>Versão</b> 1.0.0
      </div>
    </footer>
  );
};

export default Footer;